import { FormattedNumber } from 'react-intl';
import { CurrencyCode } from '@99designs/i18n';
import { toUnit } from './currency';

export function Price({
    amount,
    currency,
    minimumFractionDigits = 0,
}: {
    amount: number;
    currency: CurrencyCode;
    minimumFractionDigits?: number;
}) {
    return (
        <FormattedNumber
            value={toUnit(amount, currency)}
            // eslint-disable-next-line react/style-prop-object
            style="currency"
            currency={currency}
            minimumFractionDigits={minimumFractionDigits}
        />
    );
}
